import { DateTime } from 'luxon';
import _isPlainObject from 'lodash/isPlainObject';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isNumber = (input: any, name?: string): void => {
    if (!Number.isInteger(input)) {
        const errorMessage = name
            ? `"${name}" must be type of int.${input}`
            : 'must be type of int.';
        throw new TypeError(errorMessage);
    }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isFloat = (input: any, name?: string): void => {
    if (
        !(
            (Number(input) === input && input % 1 !== 0) ||
            Number.isInteger(input)
        )
    ) {
        const errorMessage = name
            ? `"${name}" must be type of float.`
            : 'must be type of int.';
        throw new TypeError(errorMessage);
    }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isBoolean = (input: any, name?: string): void => {
    if (typeof input !== 'boolean') {
        const errorMessage = name
            ? `"${name}" must be type of bool.`
            : 'must be type of bool.';
        throw new TypeError(errorMessage);
    }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isString = (input: any, name?: string): void => {
    if (typeof input !== 'string') {
        const errorMessage = name
            ? `"${name}" must be type of string.`
            : 'must be type of string.';
        throw new TypeError(errorMessage);
    }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isWindowFceCallable = (
    windowVarName: string,
    windowFceName: string | undefined
): void => {
    if (
        typeof windowFceName === 'undefined' ||
        !window.hasOwnProperty(windowFceName)
    ) {
        throw new TypeError(
            `Variable "${windowVarName}" has wrong value "${windowFceName}" which is not window global function. `
        );
    }
};

export const isWindowFce = (
    windowVarName: string,
    windowFceName: string | undefined
): void => {
    if (
        typeof windowVarName === 'undefined' ||
        !window.hasOwnProperty(windowVarName)
    ) {
        throw new TypeError(
            `Variable "${windowVarName}" must be type of string and defined.as global `
        );
    }

    isWindowFceCallable(windowVarName, windowFceName);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isWindowVar = (variableName: any): void => {
    if (
        typeof variableName === 'undefined' ||
        !window.hasOwnProperty(variableName)
    ) {
        const errorMessage = `"${variableName}" must be defined.as global `;
        throw new TypeError(errorMessage);
    }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isObject = (input: any, name?: string): void => {
    if (!_isPlainObject(input)) {
        const errorMessage = name
            ? `"${name}" must be type of object.`
            : 'must be type of object.';
        throw new TypeError(errorMessage);
    }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isDateTime = (input: any, name?: string): void => {
    if (!(input instanceof DateTime) || !input.isValid) {
        const errorMessage = name
            ? `"${name}" must be a valid DateTime.`
            : 'must be a valid DateTime.';
        throw new TypeError(errorMessage);
    }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isArray = (input: any, name?: string): void => {
    if (!Array.isArray(input)) {
        const errorMessage = name
            ? `"${name}" must be an array.`
            : 'must be an array.';
        throw new TypeError(errorMessage);
    }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isArrayOfInstances = (
    input: any,
    instanceType: any,
    className: string
): void => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (input.some((item: any) => !(item instanceof instanceType))) {
        const errorMessage = `must be array of "${className}".`;
        throw new TypeError(errorMessage);
    }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isInstanceOf = (
    input: any,
    instanceType: any,
    className: string
): void => {
    if (!(input instanceof instanceType)) {
        const errorMessage = `must be type of "${className}".`;
        throw new TypeError(errorMessage);
    }
};
